import clsx from 'clsx'

import type { EventKind } from '@/services/api/schemas/events'
import { AlertIcon, ClockIcon, FlameIcon, ShieldIcon } from '@/shared/icons'

import s from './EventTypeIcon.module.css'

const ICONS: Record<EventKind, typeof AlertIcon> = {
  conflict: AlertIcon,
  smoke_fire: FlameIcon,
  cashier_missing: ClockIcon,
  security_overstay: ShieldIcon,
  unknown: AlertIcon,
}

export function EventTypeIcon({ type }: { type: EventKind }) {
  const Icon = ICONS[type]
  return (
    <span className={clsx(s.icon, s[type])}>
      <Icon size={17} />
    </span>
  )
}
